import { render, staticRenderFns } from "./CampaignsView.vue?vue&type=template&id=381728d4&scoped=true"
import script from "./CampaignsView.vue?vue&type=script&lang=js"
export * from "./CampaignsView.vue?vue&type=script&lang=js"
import style0 from "./CampaignsView.vue?vue&type=style&index=0&id=381728d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381728d4",
  null
  
)

export default component.exports